import React from 'react'
import {
    BackButton,
    Bloc,
    BlocIntField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
    Title,
} from '../ImportAll'

export default function Vue11() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Quelle est votre situation professionnelle ?"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={70} time={2} />
            </div>

            <div className="Container">
                {/* Si emploi non salarié */}
                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_1"
                    isEqualTo
                    targetDataValueCompare="NS"
                >
                    {/* Si bilan insufisant  */}
                    <Conditionnal
                        linked_data_id="emprunteurs_emploi_bilan_1"
                        isEqualTo
                        targetDataValueCompare="INSUFFISANT"
                    >
                        <br />
                        <br />
                        <br />
                        {/* <Bloc nbcolumn={1} simpleDoubleWord text1="Nombres de bilan insufisant" text2="Votre nombre de bilan est insufisant pour le salaire issu de votre activité soit pris en compte."/>*/}
                    </Conditionnal>
                    {/* Si bilan sufisant on affiche  */}
                    <Conditionnal
                        linked_data_id="emprunteurs_emploi_bilan_1"
                        isNotEqualTo
                        targetDataValueCompare="INSUFFISANT"
                    >
                        <Conditionnal
                            linked_data_id="emprunteurs_type_emploi_1"
                            isEqualTo
                            targetDataValueCompare="NS_PRO_LIBERALE"
                        >
                            <BlocIntField
                                key="key102"
                                nbcolumn={1}
                                linked_data_id="emprunteurs_salaire_net_mensuel_1"
                                symbole=" €"
                                label="Revenu moyen Net mensuel sur les 2 dernières années"
                                placeholder="Ex : 2 100 € / mois"
                            />
                        </Conditionnal>
                        <Conditionnal
                            linked_data_id="emprunteurs_type_emploi_1"
                            isNotEqualTo
                            targetDataValueCompare="NS_PRO_LIBERALE"
                        >
                            <BlocIntField
                                key="key102"
                                nbcolumn={1}
                                linked_data_id="emprunteurs_salaire_net_mensuel_1"
                                symbole=" €"
                                label="Revenu moyen Net mensuel sur les 3 dernières années"
                                placeholder="Ex : 2 100 € / mois"
                            />
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>

                {/* Si emploi est salarié */}
                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_1"
                    isNotEqualTo
                    targetDataValueCompare="NS"
                >
                    <BlocIntField
                        key="key102"
                        nbcolumn={1}
                        linked_data_id="emprunteurs_salaire_net_mensuel_1"
                        symbole=" €"
                        label="Salaire net mensuel"
                        placeholder="Ex : 2 100 € / mois"
                        infobulle="Indiquez votre salaire net avant impôt. Vous le trouverez sur votre fiche de paie sous la mention « net à payer avant impôt sur le revenu »."
                    />
                    <Bloc
                        key="key103"
                        selectable
                        linked_data_id="emprunteurs_nb_mois_salaire_1"
                        linked_data_value={12}
                        nbcolumn={4}
                        gauche
                        simpleDoubleWord
                        text1="12"
                        text2="mois"
                        height={100}
                    />
                    <Bloc
                        key="key104"
                        selectable
                        linked_data_id="emprunteurs_nb_mois_salaire_1"
                        linked_data_value={13}
                        nbcolumn={4}
                        milieu
                        simpleDoubleWord
                        text1="13"
                        text2="mois"
                        height={100}
                    />
                    <Bloc
                        key="key105"
                        selectable
                        linked_data_id="emprunteurs_nb_mois_salaire_1"
                        linked_data_value={14}
                        nbcolumn={4}
                        milieu
                        simpleDoubleWord
                        text1="14"
                        text2="mois"
                        height={100}
                    />
                    <Bloc
                        key="key106"
                        selectable
                        linked_data_id="emprunteurs_nb_mois_salaire_1"
                        linked_data_value={15}
                        nbcolumn={4}
                        droit
                        simpleDoubleWord
                        text1="15"
                        text2="mois"
                        height={100}
                    />
                    <BlocIntField
                        key="key107"
                        nbcolumn={1}
                        linked_data_id="emprunteurs_primes_1"
                        symbole=" €"
                        label="Primes annuelles nettes hors intéressement et participation"
                        placeholder="Ex : 2 100 € sur l'année"
                        infobulle="Intégrer les primes récurrentes, traitement retraite, BIC ou BNC"
                    />
                </Conditionnal>
            </div>
            <div className="Container">
                <Title maintitle="Avez-vous d’autres revenus ?" />
                <Bloc
                    key="key108"
                    selectable
                    linked_data_id="emprunteurs_autre_rev_1"
                    linked_data_value="oui"
                    nbcolumn={2}
                    gauche
                    simpleWord
                    text1="Oui"
                />
                <Bloc
                    key="key109"
                    selectable
                    linked_data_id="emprunteurs_autre_rev_1"
                    linked_data_value="non"
                    nbcolumn={2}
                    droit
                    simpleWord
                    text1="Non"
                />
            </div>

            <Conditionnal
                linked_data_id="emprunteurs_autre_rev_1"
                isEqualTo
                targetDataValueCompare="oui"
            >
                <div className="Container">
                    <BlocIntField
                        key="key110"
                        nbcolumn={1}
                        linked_data_id="emprunteurs_rev_sociaux_1"
                        symbole=" €"
                        label="Revenus sociaux mensuels"
                        placeholder="Ex :  300 € / mois"
                        infobulle="Pensions invalidités, AAH, Allocations familiales"
                    />
                    <BlocIntField
                        key="key111"
                        nbcolumn={1}
                        linked_data_id="emprunteurs_rev_foncier_1"
                        symbole=" €"
                        label="Revenus fonciers mensuels"
                        placeholder="Ex : 500 € / mois"
                    />
                    <BlocIntField
                        key="key112"
                        nbcolumn={1}
                        linked_data_id="emprunteurs_rev_pensions_1"
                        symbole=" €"
                        label="Pensions mensuelles perçues"
                        placeholder="Ex : 250 € / mois"
                    />
                </div>
            </Conditionnal>

            {/* Affiche le bouton suivant  si salaire renseigné ou si Non salarié avec bilan insufisant  */}
            <Conditionnal linked_data_id="emprunteurs_autre_rev_1" isNotEmpty>
                <Conditionnal
                    linked_data_id="emprunteurs_salaire_net_mensuel_1"
                    isNotEmpty
                >
                    <Conditionnal
                        linked_data_id="emp_type_emprunteur"
                        isEqualTo
                        targetDataValueCompare="2"
                    >
                        <div className="SubmitButtonContainer">
                            {' '}
                            <Button text="Suivant" targetView={22} />{' '}
                        </div>
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="emp_type_emprunteur"
                        isNotEqualTo
                        targetDataValueCompare="2"
                    >
                        <div className="SubmitButtonContainer">
                            {' '}
                            <Button text="Suivant" targetView={12} />{' '}
                        </div>
                    </Conditionnal>
                </Conditionnal>
                <Conditionnal
                    linked_data_id="emprunteurs_salaire_net_mensuel_1"
                    isEmpty
                >
                    <Conditionnal
                        linked_data_id="emprunteurs_cat_emploi_1"
                        isEqualTo
                        targetDataValueCompare="NS"
                    >
                        <Conditionnal
                            linked_data_id="emprunteurs_emploi_bilan_1"
                            isEqualTo
                            targetDataValueCompare="INSUFFISANT"
                        >
                            <Conditionnal
                                linked_data_id="emp_type_emprunteur"
                                isEqualTo
                                targetDataValueCompare="2"
                            >
                                <div className="SubmitButtonContainer">
                                    {' '}
                                    <Button
                                        text="Suivant"
                                        targetView={22}
                                    />{' '}
                                </div>
                            </Conditionnal>
                            <Conditionnal
                                linked_data_id="emp_type_emprunteur"
                                isNotEqualTo
                                targetDataValueCompare="2"
                            >
                                <div className="SubmitButtonContainer">
                                    {' '}
                                    <Button
                                        text="Suivant"
                                        targetView={12}
                                    />{' '}
                                </div>
                            </Conditionnal>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>
        </div>
    )
}
